import {
  isRegExp
} from "util";

export const toggleVisibility = {
  data: function () {
    var vm = this;
    return {
      uuid: vm.create_UUID()
    }
  },
  methods: {
    create_UUID: function () {
      var dt = new Date().getTime();
      var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (dt + Math.random() * 16) % 16 | 0;
        dt = Math.floor(dt / 16);
        return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
      });
      return "modal-" + uuid;
    },
    close: function (cb) {
      this.$emit('closed');
      if (cb == 'n') {
        this.Ncallback();
      } else if (cb == 'y') {
        this.Ycallback();
      }
      this.$refs[this.uuid].close();
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/dynamic/modalWrapper/toggleVisibilityMixin.js